module.exports = __webpack_public_path__ + "assets/img/car-banner.d1afe944.png";